/**
 * Backend `tenantResolution` rejects non-ACTIVE tenants with HTTP 403 + `TENANT_INACTIVE`.
 * Frontends must show durable copy — never a cryptic 403 / raw status only.
 */
import { ApiError } from './ApiClient.js';

export const TENANT_INACTIVE_CODE = 'TENANT_INACTIVE' as const;

/** Stable hook for Playwright T19 ACTIVE smoke + TENANT_INACTIVE UX specs. */
export const CUSTOMER_TENANT_INACTIVE_TEST_ID = 'customer-tenant-inactive' as const;

export function isTenantInactiveError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.code === TENANT_INACTIVE_CODE;
  }
  if (typeof error === 'object' && error !== null && 'code' in error) {
    return (error as { code?: unknown }).code === TENANT_INACTIVE_CODE;
  }
  return false;
}
